import React, {Component} from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import ColumnModel from '../../models/datasource/column';
import {FEATURE_FLAGS} from '../../services/feature_flags';
import {globalClickEvent, globalMenuOpenEvent} from '../../services/global_events';
import {
    columnHoverEvent,
    columnLeaveEvent,
    columnSelectEvent, inputFocusEvent, tableActionEvent,
} from '../../services/query_builder_events';
import stopEvent from '../../utils/stop_event';
import pipelineStepPropType from "../../utils/pipeline_step_proptype";
import PIPELINE_STEPS from "../../utils/pipeline_steps";

class DataTableTableHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMenu: false,
        };
    }

    componentDidMount() {
        this.unbindGlobalEvent = globalClickEvent.listen(() => { this.setState({showMenu: false}); });
        this.unbindGlobalMenuEvent = globalMenuOpenEvent.listen((menu) => { this.setState({showMenu: menu === 'table'}); });
        this.unbindInputFocusListener = inputFocusEvent.listen(() => { this.setState({showMenu: false}); });
    }

    componentWillUnmount() {
        this.unbindGlobalEvent();
        this.unbindGlobalMenuEvent();
        this.unbindInputFocusListener();
    }

    toggleMenu() {
        globalMenuOpenEvent.emit(this.state.showMenu ? undefined : 'table');
    }

    render() {
        const {menu, showTableMenu} = this.props;
        const {showMenu} = this.state;
        return (
            <>
                <th className="table-action-column">
                    {showTableMenu &&
                        <div>
                            <>
                                <button
                                    className="table-header-menu-button options-button"
                                    onClick={stopEvent(() => { this.toggleMenu(); })}
                                >
                                    <img alt="" src="/images/transformations-tbl-menu.svg"/>
                                </button>
                                {showMenu && (
                                    <ul className="filter-list w-list-unstyled table-header-menu dropdown-menu">
                                        <span>TABLE ACTIONS</span>
                                        {menu.map(({label, onClick = () => {}, actions = []}) => (
                                            <li
                                                key={label}
                                                className="table-header-menu-item dropdown-item"
                                                onClick={stopEvent(() => { onClick(); })}
                                            >
                                                {label}
                                                {actions.map(action => (
                                                    <button
                                                        key={action.label}
                                                        className="button"
                                                        onClick={action.onClick}
                                                    >
                                                        <img src={`/images/${action.icon}.svg`} alt={action.label} />
                                                    </button>
                                                ))}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </>
                        </div>
                    }
                </th>
            </>
        );
    }
}

DataTableTableHeader.propTypes = {
    menu: PropTypes.arrayOf(PropTypes.shape({label: PropTypes.string, onClick: PropTypes.func})),
    showTableMenu: PropTypes.bool.isRequired,
};

class DataTableColumnHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMenu: false,
        };

        this.toggleMenu = this.toggleMenu.bind(this);
    }

    componentDidMount() {
        this.unbindGlobalEvent = globalClickEvent.listen(() => { this.setState({showMenu: null}); });
        this.unbindGlobalMenuEvent = globalMenuOpenEvent.listen((menu = null) => { this.setState({showMenu: menu}); });
        this.unbindInputFocusListener = inputFocusEvent.listen(() => { this.setState({showMenu: null}); });
    }

    componentWillUnmount() {
        this.unbindGlobalEvent();
        this.unbindGlobalMenuEvent();
        this.unbindInputFocusListener();
    }

    toggleMenu(column) {
        if (!column || this.state.showMenu === column.label) {
            globalMenuOpenEvent.emit();
        } else {
            globalMenuOpenEvent.emit(column.label);
        }
    }

    render() {
        const {
            columns,
            highlightedColumnIndex,
            registerColumnRef,
            columnMenu,
            tableMenu,
            onClick,
            onHover,
            onLeave,
            renderLabel,
            showRowNums,
            showTableMenu,
            step,
            editingPipelineStep,
        } = this.props;
        const {showMenu} = this.state;
        return (
            <>
                <tr className="column-name-header">
                    {showRowNums &&
                        <DataTableTableHeader
                            menu={tableMenu}
                            showTableMenu={showTableMenu}
                        />
                    }
                    {columns.map((column, colNum) => (
                        <th
                            key={`header_${colNum}`}
                            className={`
                                ${colNum === highlightedColumnIndex ? 'highlight' : ''}
                                ${column.label === showMenu ? 'current-menu' : ''}
                                ${editingPipelineStep && step && step.columnId === column.id ? 'current-menu' : ''}
                            `}
                            ref={el => registerColumnRef(column, el)}
                            onClick={() => { onClick(column); }}
                            onMouseEnter={() => { onHover(column); }}
                            onMouseLeave={() => { onLeave(column); }}
                        >
                            <div>
                                {renderLabel ?
                                   renderLabel(column) :
                                    <span className="column-name-header-text">{column.label}</span>
                                }
                                {columnMenu && (
                                    <>
                                        <button
                                            className="column-header-menu-button options-button"
                                            onClick={stopEvent(() => { this.toggleMenu(column); })}
                                        >
                                            <img alt="" src="/images/transformations-col-menu.svg" />
                                        </button>
                                        {showMenu === column.label && (
                                            <ul className="filter-list w-list-unstyled column-header-menu dropdown-menu">
                                                <span>COLUMN ACTIONS</span>
                                                {columnMenu.map(({label, onClick = () => {}, actions = []}) => (
                                                    <li
                                                        key={label}
                                                        className="column-header-menu-item dropdown-item"
                                                        onClick={stopEvent(() => { onClick(column); })}
                                                    >
                                                        <div className="column-menu-item-label">{label}</div>
                                                        {actions.length > 0 && (
                                                            <div className="column-menu-item-actions">
                                                                {actions.map(action => (
                                                                    <button
                                                                        key={action.label}
                                                                        className="button"
                                                                        onClick={stopEvent(() => { action.onClick(column); })}
                                                                    >
                                                                        <img src={`/images/${action.icon(column)}.svg`} alt={action.label} />
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </>
                                )}
                            </div>
                        </th>
                    ))}
                </tr>
            </>
        );
    }
}

DataTableColumnHeader.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.instanceOf(ColumnModel)).isRequired,
    highlightColumn: PropTypes.string,
    registerColumnRef: PropTypes.func,
    columnMenu: PropTypes.arrayOf(PropTypes.shape({label: PropTypes.string, onClick: PropTypes.func})),
    tableMenu: PropTypes.arrayOf(PropTypes.shape({label: PropTypes.string, onClick: PropTypes.func})),
    showGroups: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    onHover: PropTypes.func.isRequired,
    onLeave: PropTypes.func.isRequired,
    renderLabel: PropTypes.func,
    showRowNums: PropTypes.bool,
    step: pipelineStepPropType,
    editingPipelineStep: PropTypes.bool.isRequired,
};

DataTableColumnHeader.defaultProps = {
    showGroups: false,
    showRowNums: false,
    showTableMenu: false,
};

export default class DataTable extends Component {
    tableMenu = [
        {
            label: '+Calculated Column',
            onClick: this.tableAddColumn.bind(this),
        },
    ];

    constructor(props) {
        super(props);

        this.state = {
            currentMenu: null,
        };

        this.onClick = this.onClick.bind(this);
        this.onHover = this.onHover.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.onMenuToggle = this.onMenuToggle.bind(this);
    }

    componentDidMount() {
        this.unbindGlobalMenuEvent = globalMenuOpenEvent.listen((menu = null) => { this.setState({currentMenu: menu}); });
        this.unbindGlobaClickEvent = globalClickEvent.listen(() => { this.setState({currentMenu: null}); });
        this.unbindInputFocusEvent = inputFocusEvent.listen(() => { this.setState({currentMenu: null}); });
    }

    componentWillUnmount() {
        this.unbindGlobalMenuEvent();
        this.unbindGlobaClickEvent();
        this.unbindInputFocusEvent();
    }

    onClick(column) {
        if (this.props.fireEvents) {
            columnSelectEvent.emit(column);
        }
    }

    onHover(column) {
        if (this.props.fireEvents) {
            columnHoverEvent.emit(column, true);
        }
    }

    onLeave(column) {
        if (this.props.fireEvents) {
            columnLeaveEvent.emit(column);
        }
    }

    onMenuToggle(menu) {
        this.setState({currentMenu: menu});
    }

    tableAddColumn() {
        tableActionEvent.emit(PIPELINE_STEPS.ADD_COLUMN, {parent: this.props.step});
    }

    getTableMenu() {
        if (FEATURE_FLAGS.TABLE_MENU_SIDE) {
            return [];
        }

        return this.tableMenu;
    }

    render() {
        let {
            data: {name = '', columns = [], rows = []},
            zebraStripes,
            limit,
            highlightColumn,
            registerColumnRef,
            columnMenu,
            fireEvents,
            showGroups,
            renderColumnHeader,
            hasExecuted,
            onExecute,
            showRowNums,
            showTableMenu,
            step,
            editingPipelineStep,
        } = this.props;
        const {currentMenu}  = this.state;
        const numRows = rows.length;
        const highlightedColumnIndex = columns.findIndex(({id}) => highlightColumn === id);
        if (limit) {
            rows = rows.slice(0, limit);
        }

        return (
            <table className={`${zebraStripes ? 'with-zebra-stripes' : ''} ${currentMenu === 'table' ? 'current-menu' : ''}`}>
                <thead>
                    {!!name && (
                        <tr className="table-name-header">
                            <th colSpan={columns.length}>
                                <img src="images/table.svg" alt=""/>
                                {name}
                            </th>
                        </tr>
                    )}
                    <DataTableColumnHeader
                        columns={columns}
                        highlightedColumnIndex={highlightedColumnIndex}
                        registerColumnRef={registerColumnRef}
                        columnMenu={columnMenu}
                        tableMenu={this.getTableMenu()}
                        showTableMenu={showTableMenu}
                        showGroups={showGroups}
                        onClick={this.onClick}
                        onHover={this.onHover}
                        onLeave={this.onLeave}
                        renderLabel={renderColumnHeader}
                        showRowNums={showRowNums}
                        onMenuToggle={this.onMenuToggle}
                        step={step}
                        editingPipelineStep={editingPipelineStep}
                    />
                </thead>
                <tbody>
                {rows.map((row, rowNum) => (
                    <tr key={`row_${rowNum}`}>
                        {showRowNums && <td className="table-action-column">{rowNum + 1}</td>}
                        {row.map((cellValue, colNum) => (
                            <td
                                key={`${rowNum}_${colNum}`}
                                className={`
                                    ${FEATURE_FLAGS.HIGHLIGHT_TABLE_VALUES && colNum === highlightedColumnIndex ? 'highlight' : ''}
                                    ${fireEvents ? 'selectable' : ''}
                                    ${currentMenu === columns[colNum].label ? 'current-menu' : ''}
                                    ${editingPipelineStep && step && step.columnId === columns[colNum].id ? 'current-menu': ''}
                                `}
                                // Disabling to see if users are less likely to click the values in the table if they get no response
                                onClick={() => { this.onClick(columns[colNum]); }}
                                onMouseEnter={() => { this.onHover(columns[colNum]); }}
                                onMouseLeave={() => { this.onLeave(columns[colNum]); }}
                            >
                                {cellValue}
                            </td>
                        ))}
                    </tr>
                ))}
                {(hasExecuted || !onExecute) && rows.length < numRows && (
                    <tr>
                        <td colSpan={columns.length + 1} className="query-preview-message">
                            Previewing {rows.length} of {pluralize('row', numRows, true)}
                        </td>
                    </tr>
                )}
                </tbody>
                <tfoot>
                <tr>
                    <td colSpan={columns.length + 1}>
                    {this.getTableMenu().map(({label, onClick}) => (
                        <span key={label} onClick={() => onClick()}>{label}</span>
                    ))}
                    </td>
                </tr>
                </tfoot>
            </table>
        );
    }
}

DataTable.propTypes = {
    data: PropTypes.shape({
        name: PropTypes.string,
        columns: PropTypes.arrayOf(PropTypes.instanceOf(ColumnModel)).isRequired,
        rows: PropTypes.arrayOf(
            PropTypes.arrayOf(
                PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.number,
                    PropTypes.bool,
                ])
            )
        ).isRequired,
    }),
    zebraStripes: PropTypes.bool,
    limit: PropTypes.number,
    highlightColumn: PropTypes.string,
    registerColumnRef: PropTypes.func,
    columnMenu: PropTypes.arrayOf(PropTypes.shape({label: PropTypes.string, onClick: PropTypes.func})),
    fireEvents: PropTypes.bool,
    renderColumnHeader: PropTypes.func,
    hasExecuted: PropTypes.bool,
    onExecute: PropTypes.func,
    showRowNums: PropTypes.bool,
    step: pipelineStepPropType,
    editingPipelineStep: PropTypes.bool,
};

DataTable.defaultProps = {
    zebraStripes: true,
    limit: 0,
    highlightColumn: null,
    registerColumnRef() {},
    fireEvents: false,
    hasExecuted: false,
    showRowNums: false,
    editingPipelineStep: false,
};
